<template>
  <!-- 月次集計 -->
  <div id="total">
    <CCard>
      <CCardHeader><h2>月次集計</h2></CCardHeader>
      <CCardBody>
        <table class="table search-table">
          <tr>
            <th style="width: 100px; text-align: left;" class="horizontal-text">年月</th>
            <th style="width: 75px"></th>
            <th style="width: 50px"></th>
            <th colspan="2"></th>
          </tr>
          <tr>
            <td>
              <select
                class="custom-select"
                v-model="year"
                style="width: 90px"
              >
                <option
                  v-for="option in yearOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>
              <select
                class="custom-select"
                v-model="month"
                style="width: 70px"
              >
                <option
                  v-for="option in monthOption"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
            </td>
            <td>業務分</td>   
            <td>
              <button class="btn btn-primary" @click="callList">検索</button>
            </td>
          </tr>
        </table>
      </CCardBody>
      <template v-if="callFlg">
        <CCardBody>
          <div class="d-flex justify-content-end mb-2">
            <button class="btn btn-info ml-2" :disabled="items.length === 0" @click="openPDF()">
                PDF
            </button>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" rowspan="2" width="50px">社員番号</th>
                  <th scope="col" rowspan="2" width="50px">社員名</th>
                  <th scope="col" colspan="3" class="horizontal-text" width="50px">ステータス</th>
                  <th scope="col" rowspan="2" width="50px">所定労働日数</th>
                  <th scope="col" rowspan="2" width="50px">出勤日数</th>
                  <th scope="col" rowspan="2" width="50px">有休日数</th>
                  <th scope="col" rowspan="2" width="50px">代休日数</th>
                  <th scope="col" rowspan="2" width="50px">特別休暇日数</th>
                  <th scope="col" rowspan="2" width="50px">総労働時間</th>
                  <th scope="col" rowspan="2" width="50px">欠勤時間</th>
                  <th scope="col" rowspan="2" width="50px">固定内残業</th>
                  <th scope="col" rowspan="2" width="50px">固定外残業</th>
                  <th scope="col" rowspan="2" width="50px">残手全対象</th>
                  <th scope="col" rowspan="2" width="50px">残手割増のみ</th>
                  <th scope="col" rowspan="2" width="50px">法定休日作業</th>
                  <th scope="col" rowspan="2" width="50px">深夜作業</th>
                  <th scope="col" rowspan="2" width="50px">45時間超残業</th>
                  <th scope="col" rowspan="2" width="50px">60時間超残業</th>
                  <th scope="col" rowspan="2" width="50px">有休残日数</th>
                  <th scope="col" rowspan="2" width="50px">代休残日数</th>
                  <th scope="col" rowspan="2" width="50px">欠勤日数</th>
                  <th scope="col" rowspan="2" width="50px">非課税通勤費</th>
                  <th scope="col" rowspan="2" width="50px">経費</th>
                </tr>
                <tr>
                  <th class="horizontal-text" width="20px">勤怠</th>
                  <th class="horizontal-text" width="20px">経費</th>
                  <th class="horizontal-text" width="20px">交通費</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>{{ item.employee_id }}</td>
                  <td>{{ item.name }}</td>
                  <td :style="statusColor(displayStatus(item.status_work) )" class="horizontal-text"  nowrap>{{ displayStatus(item.status_work) }}</td>
                  <td :style="statusColor(displayStatus(item.status_expenses))" class="horizontal-text"  nowrap>{{ displayStatus(item.status_expenses) }}</td>
                  <td :style="statusColor(displayStatus(item.status_trans))" class="horizontal-text"  nowrap>{{ displayStatus(item.status_trans) }}</td>
                  <td class="text-right">{{ item.defined_attendance_day }}</td>
                  <td class="text-right">{{ item.sum_attendance_day }}</td>
                  <td class="text-right">{{ item.paid_holiday_used }}</td>
                  <td class="text-right">{{ item.substitute_holiday_used }}</td>
                  <td class="text-right">{{ item.special_holiday_used }}</td>
                  <td class="text-right">{{ item.sum_work_time }}</td>
                  <td class="text-right">{{ item.sum_deduction_time }}</td>
                  <td class="text-right">{{ item.sum_fixed_over_time }}</td>
                  <td class="text-right">{{ item.sum_over_time }}</td>
                  <td class="text-right">{{ item.full_over_time }}</td>
                  <td class="text-right">{{ item.just_pre_over_time }}</td>
                  <td class="text-right">{{ item.sum_holiday_time }}</td>
                  <td class="text-right">{{ item.sum_night_time }}</td>
                  <td class="text-right">{{ item.over_45_time }}</td>
                  <td class="text-right">{{ item.over_60_time}}</td>
                  <td class="text-right">{{ item.paid_holiday_remain }}</td>
                  <td class="text-right">{{ item.substitute_holiday_remain }}</td>
                  <td class="text-right">{{ item.absence_day }}</td>
                  <td class="text-right">{{ item.commuting_expenses }}</td>
                  <td class="text-right">{{ item.expenses }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-center">
            <!-- ページング処理 -->
            <VPagination
              v-model="currentPage"
              :click-handler="changePage"
              :page-count="totalPages"
              :force-ellipses="true"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :prev-text="'<'"
              :next-text="'>'"
              :prev-link-class="'page-link'"
              :next-link-class="'page-link'"
              :page-link-class="'page-link'"
              :class-prefix="'pagination'"
            />
          </div>
        </CCardBody>
      </template>
    </CCard>
  </div>
</template>
  
<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import moment from "moment";
import VPagination from "vuejs-paginate";
export default {
  name: "Total",
  components: {
    VPagination,
  },
  data() {
    return {
      year: "",
      month: "",
      date: "",
      items: [],
      callFlg: false,
      monthlyReportInfo: "",
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      item: {
      over_45_time: "",
      over_60_time: ""
    },
    };
  },
  created() {
    this.yearOption = ConstList.YEAR_OPTION;
    this.monthOption = ConstList.MONTH_OPTION;
    this.reportInfo = ConstList.ROUTE_REPORT_INFO;
  },

  methods: {
    callList: function () {
      this.callFlg = false;
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      this.fetchTotalPages();
      params.append("currentPage", this.currentPage);
      params.append("pageSize", this.pageSize);
      params.append("totalPages", this.totalPages);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/List", {
          params: {
            year: this.year,
            month: this.month,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          this.items = response.data;
          this.callFlg = true;
          // sessionStorageへ保存
          sessionStorage.setItem(
            "monthlyreportsList-search-items",
            JSON.stringify(this.items)
          );
          sessionStorage.setItem(
            "monthlyreportsList-search-params",
            JSON.stringify({
              year: this.year,
              month: this.month,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              totalPages: this.totalPages,
            })
          );
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    setBlue: function (bluenum, index) {
      if (this.blue[index][bluenum] === "blue") {
        this.blue[index].splice(bluenum, 1, "");
      } else {
        this.blue[index].splice(bluenum, 1, "blue");
      }
    },
    setYellow: function (yellownum, index) {
      if (this.yellow[index][yellownum] === "yellow") {
        this.yellow[index].splice(yellownum, 1, "");
      } else {
        this.yellow[index].splice(yellownum, 1, "yellow");
      }
    },
    // 承認状態の初期値
    displayStatus(status) {
    return status ? status : ConstList.UNSUBMITTED; 
  },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    //PDF出力メソッド
    openPDF: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);

      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/pdf", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank");
        })
        .catch((error) => {
          axios
          .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`)
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },

    // ページ変更
    changePage: function (page) {
      this.currentPage = page;
      this.callList();
    },
    // アイテム数とページサイズに基づいて合計ページ数を計算
    fetchTotalPages: function () {
      const params = new URLSearchParams();
      params.append("year", this.year);
      params.append("month", this.month);
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/admin/total/count", {
          params: {
            year: this.year,
            month: this.month,
          },
        })
        .then((response) => {
          const totalCount = response.data;
          this.totalPages = Math.ceil(totalCount / this.pageSize);
        })
        .catch((error) => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
  },

  computed: {
    // 入力欄を追加・削除出来るようにする
    lists: function () {
      return Array.from(Array(this.num).keys());
    },
  },

  mounted: function () {
    // 前回の検索パラメータがあれば取得
    if (
      Object.prototype.hasOwnProperty.call(
        sessionStorage,
        "monthlyreportsList-search-items"
      )
    ) {
      const params = JSON.parse(
        sessionStorage.getItem("monthlyreportsList-search-params")
      );
      this.year = params.year;
      this.month = params.month;
      this.callList();
      this.callFlg = true;
    }else{
      const today = moment().subtract(1, 'months');
      this.year = today.format("YYYY");
      this.month = today.format("M");
    }
  },
};
</script>
  
<style scoped>
td,
th {
  white-space: nowrap;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

td {
  vertical-align: middle;
  white-space: nowrap;
}
th {
  writing-mode:vertical-rl;
}
.horizontal-text {
  writing-mode: horizontal-tb;
  text-align: center;
  vertical-align: middle;
}
</style>
  